import { useQuery } from 'react-query';
import { axiosRequestHandler } from 'helpers/Requests';
import { INonReactModalData } from 'interfaces/modal';

export function useModalData(queryKey: string) {
  return useQuery<INonReactModalData, Error>(
    queryKey,
    async () => {
      const response = await axiosRequestHandler(queryKey);
      return response.data as INonReactModalData;
    },
    {
      staleTime: Infinity,
    }
  );
}
